export default function getMimeType(file: File) {
  const [type] = file.type.split('/');
  const subType = file.name.split('.').pop();

  return {type, subType};
}
